// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-c1980640]::-webkit-inner-spin-button,input[data-v-c1980640]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-c1980640]{-moz-appearance:textfield}", ""]);
// Exports
module.exports = exports;
